var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7501 0.916626H8.25008C7.84081 0.916626 7.48112 1.18794 7.36868 1.58146L6.28168 5.38596C4.6828 6.73118 3.66675 8.74691 3.66675 11C3.66675 13.253 4.6828 15.2687 6.28168 16.614L7.36868 20.4185C7.48112 20.812 7.84081 21.0833 8.25008 21.0833H13.7501C14.1594 21.0833 14.519 20.812 14.6315 20.4185L15.7185 16.614C17.0971 15.4541 18.0424 13.7958 18.2767 11.9166H19.2501V10.0833H18.2767C18.0424 8.20416 17.0971 6.54583 15.7185 5.38596L14.6315 1.58146C14.519 1.18794 14.1594 0.916626 13.7501 0.916626ZM11.0001 3.66663C11.8552 3.66663 12.6762 3.81299 13.4392 4.08204L13.0586 2.74996H8.94152L8.56093 4.08204C9.324 3.81299 10.1449 3.66663 11.0001 3.66663ZM8.94152 19.25L8.56093 17.9179C9.324 18.1869 10.1449 18.3333 11.0001 18.3333C11.8552 18.3333 12.6762 18.1869 13.4392 17.9179L13.0586 19.25H8.94152ZM16.5001 11C16.5001 14.0375 14.0376 16.5 11.0001 16.5C7.96251 16.5 5.50008 14.0375 5.50008 11C5.50008 7.96239 7.96251 5.49996 11.0001 5.49996C14.0376 5.49996 16.5001 7.96239 16.5001 11ZM11.9167 10.0833H13.7501V11.9166H10.0834V7.33329H11.9167V10.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.a328f713791ad2183138475c675eb4c4.svg";
export { ForwardRef as ReactComponent };